module.exports = __webpack_public_path__ + "static/media/Ellipse.2dd12a86.svg";